// The full-size copy of a photo a buyer sent in an eBay message (2026-10-27,
// prod contact 8250173; docs/image-label-read.md "Full size",
// docs/contact-view.md "Photo viewer"). One helper for the UI's lightbox and
// the server's photo read, so both ask eBay's picture CDN (i.ebayimg.com) for
// the same copy.
//
// The stored mediaUrl (mapper.js keeps eBay's messageMedia[].mediaUrl
// verbatim) is a ~400px thumbnail. The CDN serves the same photo at other
// sizes, chosen by a size code in the file name. Measured in a browser on a
// 720x1544 original (2026-10-27):
//
//   /00/s/<base64 dims>/z/<id>/$_N.<ext>[?set_id=…]  (the shape buyer
//   message photos have; the dims segment decodes to e.g. "1544X720")
//     $_1     186x400   (what was shown before)
//     $_12    233x500
//     $_10    720x1544  (full size)
//     $_57    720x1544  (full size, with or without the query string)
//     s-l1600 an 80x80 placeholder: broken on this path, never used here
//
//   /images/g/<id>/s-lNNN.<ext>[?query]  (the newer listing-photo shape)
//     s-lNNN  NNN px on the longer side; s-l1600 is the largest
//
// ebayFullSizeImageUrl():
//   /00/s/…/z/…/$_N.<ext>   -> $_57.<ext>, the query string kept
//   /images/g/…/s-lNNN.<ext> -> s-l1600.<ext>, the query string kept
//   anything else (another host, http, an unknown shape, not a string) is
//   returned unchanged: never a guess, never a host or scheme change.
const EBAY_DIMS_PATH_RE = /^(https:\/\/i\.ebayimg\.com\/00\/s\/[^/?#]+\/z\/[^/?#]+\/)\$_\d+(\.[A-Za-z0-9]+)((?:\?[^#]*)?)$/
const EBAY_IMAGES_G_RE = /^(https:\/\/i\.ebayimg\.com\/images\/g\/[^/?#]+\/)s-l\d+(\.[A-Za-z0-9]+)((?:\?[^#]*)?)$/

export const EBAY_FULL_SIZE_CODE_DIMS_PATH = '$_57'
export const EBAY_FULL_SIZE_CODE_IMAGES_G = 's-l1600'

export function ebayFullSizeImageUrl(url) {
  if (typeof url !== 'string') return url
  let m = EBAY_DIMS_PATH_RE.exec(url)
  if (m) return `${m[1]}${EBAY_FULL_SIZE_CODE_DIMS_PATH}${m[2]}${m[3]}`
  m = EBAY_IMAGES_G_RE.exec(url)
  if (m) return `${m[1]}${EBAY_FULL_SIZE_CODE_IMAGES_G}${m[2]}${m[3]}`
  return url
}

// Whether a URL is on eBay's picture CDN over https: the only image host the
// server's photo read fetches from (besides our own attachment storage).
export function isEbayImageUrl(url) {
  return typeof url === 'string' && /^https:\/\/i\.ebayimg\.com\//.test(url)
}
